<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             icon="la la-link"
             width="700"
             @opened="loadItems">
    <template slot="body-content">
      <aside class="tag-feed-items-modal">
        <div v-if="!loading" class="tag-feed-items-list">
          <b-card v-for="feed in feeds_with_items" :key="feed.uuid"
                  :header="`Feed: ${feed.name}`"
                  class="mt-4">
            <b-card-text>
              <b-row>
                <b-col cols="6">
                  <p><strong>Tags</strong></p>
                  <div v-if="feed.tags && feed.tags.length">
                    <multi-select-tag-bag :tags-list="feed.tags.map(tag => tag.name)" />
                  </div>
                  <div v-else>
                    Feed has no Tags; nothing to sync.
                  </div>
                </b-col>
                <b-col cols="6">
                  <collapse-text v-if="feed.items && feed.items.length" text-classes="font-weight-bold"
                                 :text="`Items to Sync: ${feed.items.length}`"
                                 :indent-content="false">
                    <ul class="clean-list mt-3">
                      <li v-for="item in feed.items" :key="item.uuid">
                        <a :href="`/items/${item.uuid}/edit`"
                           target="_blank">
                          {{ item.name }}
                        </a>
                      </li>
                    </ul>
                  </collapse-text>
                  <div v-else>
                    Feed has no Items, nothing to sync.
                  </div>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </div>
        <div v-else class="tag-feed-items-list">
          <b-card>
            <b-card-text>
              Loading...
            </b-card-text>
          </b-card>
        </div>
      </aside>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" :disabled="waiting_callback" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" />Confirm
      </b-button>
      <b-button variant="ss-cancel" :disabled="waiting_callback" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" />Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import MultiSelectTagBag from 'VueComponents/MultiSelectTagBag';
import CollapseText from 'VueComponents/CollapseText';

export default {
  name: `sync-tags-to-items-modal`,
  components: {
    VjsModal,
    MultiSelectTagBag,
    CollapseText,
  },
  mixins: [VjsModalMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: "Syncing Tags from Selected Feeds:",
    },
    feeds: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    feeds_with_items: null,
  }),
  methods: {
    getFeedItems(feed) {
      return new Promise((res, rej) => {
        axios.get(`/api/v1/items?feed_uuid=${feed.uuid}`).then((response) => {
          this.loaded_feeds_count++;
          res(response.data.data);
        }).catch((err) => {
          toastr.error(`could not retrieve items for feed ${feed.name}`);
          window.handleAxiosError(err);
          rej(err);
        });
      });
    },
    close(confirmed) {
      this.close_data.confirm = confirmed;
      this.complete();
    },
    async loadItems() {
      this.loading = true;
      const feeds = [...this.feeds];
      this.feeds_with_items = null;
      for (const feed of feeds) {
        feed.items = await this.getFeedItems(feed);
      }
      this.feeds_with_items = feeds;
      this.loading = false;
    },
  },
};
</script>
